// Grid item double height plugin
$.fn.gridItemDoubleHeight = function() {
    var $this = $(this);
    
    function setGridItemDoubleHeight() {
        $this.each(function() {
            var $this = $(this);
            
            // Remove forced grid item wrap
            $('.js-grid-item-break').remove();
            
            // Reset style/class adjustments    
            $this
                .removeClass('js-grid-item-h-x2--ready')
                .css({
                    'min-height': '',
                    'margin-bottom': ''
                });
            if (mlnViewport().width >= 1200) {                
                var currentRowHeight = $this.prev().height(),
                    nextRowHeight = $this.next().height(),
                    doubleHeight = currentRowHeight + nextRowHeight,
                    marginBottomOffset = -Math.abs(nextRowHeight);
                
                $('<div class="js-grid-item-break d-none d-xl-block"></div>')
                    .insertAfter($this.next().next());
                
                $this.addClass('js-grid-item-h-x2--ready');
                
                $this.css('cssText', 'margin-bottom: ' + marginBottomOffset + 'px !important;');
                
                $this.css({
                    'min-height': doubleHeight
                });    
            }      
        });    
    }
    
    // Run function
    setGridItemDoubleHeight();
    
    // Run function after resize
    $(window).on('resizeEnd', function() {
        setGridItemDoubleHeight();
    });
};

// Initialize after window is done loading everything
$(window).on('load', function() {
    $('.js-grid-item-h-x2').gridItemDoubleHeight();
});


$(function() {

    // Clickable CTAs
    $('.clickable').each(function() {        
        var $this = $(this),
            imgLink = $this.find('a img'),
            down,
            up,
            link = ($this.find('a').length === 1) ? $this.find('a') : $this.find('.clickable__anchor'),
            middleClick,
            auxClick;

        if (imgLink.length) {
            imgLink.unwrap();
        }
        if (!link.length) {
            $this.removeClass('clickable');
        }

        $this.on('mousedown', function(e) {
            down = + new Date();
            middleClick = (e.which === 2) ? true : false;  
            auxClick = (e.which === 3) ? true : false;             
        }).on('mouseup', function() {
            up = +new Date();

            if ((up - down) < 200 && auxClick === false) {
                link[0].click();
            }
        });
    });
});